export const WS_UPDATE_TYPES = {
    DESCRIPTIONS_READY: 'descriptions_ready',
    SLIDE_PROCESSED: 'slide_processed',
    PROCESSING_COMPLETE: 'processing_complete',
    BATCH_STARTED: 'batch_started',
    BATCH_PROCESSING: 'batch_processing',
    SLIDE_SKIPPED: 'slide_skipped',
    SLIDES_FAILED: 'slides_failed',
    DECK_COMPLETE: 'deck_complete',
    RAG_FILE_PROGRESS: 'rag_file_progress',
    RAG_BATCH_COMPLETE: 'rag_batch_complete',
    RAG_FILE_SKIPPED: 'rag_file_skipped',
    RAG_FILE_CANCELLED: 'rag_file_cancelled',
    RAG_ERROR: 'rag_error',
    RAG_BATCH_ERROR: 'rag_batch_error',
    BUILD_AREA_COMPLETED: 'build_area_completed',
    BUILD_SECTION_STARTED: 'build_section_started',
    BUILD_SECTION_COMPLETED: 'build_section_completed',
    BUILD_ERROR: 'build_error',
    BUILD_COMPLETED: 'build_completed',
    BUILD_PAUSED: 'build_paused',
    PING: 'ping',
    ERROR: 'error',
};
const TOP_LEVEL_ENVELOPE_KEYS = new Set([
    'connection_type',
    'update_type',
    'update_data',
    'deck_id',
    'documentId',
    'workbook_id',
    'timestamp',
    'type',
    'data',
]);
function extractFallbackUpdateData(raw) {
    const updateData = {};
    for (const [key, value] of Object.entries(raw)) {
        if (!TOP_LEVEL_ENVELOPE_KEYS.has(key)) {
            updateData[key] = value;
        }
    }
    return updateData;
}
export function normalizeWebSocketEvent(raw) {
    const normalizedType = String(raw.update_type || raw.type || 'unknown');
    const normalizedData = (raw.update_data && typeof raw.update_data === 'object' ? raw.update_data : null) ||
        (raw.data && typeof raw.data === 'object' ? raw.data : null) ||
        extractFallbackUpdateData(raw);
    const normalizeddocumentId = typeof raw.deck_id === 'string'
        ? raw.deck_id
        : typeof raw.documentId === 'string'
            ? raw.documentId
            : undefined;
    const normalizedTimestamp = typeof raw.timestamp === 'number' && Number.isFinite(raw.timestamp)
        ? raw.timestamp
        : typeof raw.timestamp === 'string' && Number.isFinite(Date.parse(raw.timestamp))
            ? Date.parse(raw.timestamp)
            : Date.now();
    return {
        ...raw,
        update_type: normalizedType,
        update_data: normalizedData,
        deck_id: normalizeddocumentId,
        timestamp: normalizedTimestamp,
        type: typeof raw.type === 'string' ? raw.type : normalizedType,
        data: raw.data ?? normalizedData,
    };
}
